module.exports = __webpack_public_path__ + "static/img/tx_2.4da752d1.png";